import { call, put } from "redux-saga/effects";
import apiChat from "../../services/apiChat";

import UsersActions from "../ducks/users";

export function* getUsers({ key, userId, admin }) {
  try {
    const response = yield call(
      apiChat.get,
      `user?key=${key}&&userId=${userId}&&admin=${admin}`
    );

    yield put(UsersActions.getUsersSuccess(response.data));
  } catch (err) {
    yield put();
    // TODO
  }
}



// WEBPACK FOOTER //
// ./src/storeChat/sagas/users.js